var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysApplyArrow = function SvgSysApplyArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.5 13a.48.48 0 0 1-.187-.033l-.04-.018h-.008l-.03-.017-.021-.014c-.006-.004-.012-.01-.017-.016l-.026-.02-.013-.01-.012-.013-3-3a.502.502 0 0 1 .163-.814.5.5 0 0 1 .546.11l2.142 2.142V3.506a.5.5 0 0 1 1 0V11.3l2.147-2.147a.5.5 0 0 1 .7.705l-3 3a.39.39 0 0 1-.072.059h-.007a.301.301 0 0 1-.035.022h-.008l-.036.017h-.008a.301.301 0 0 1-.038.014l-.003.002-.004-.002a.275.275 0 0 1-.041.01l-.043.005a.337.337 0 0 1-.045 0L8.5 13Z"
  })));
};
export default SvgSysApplyArrow;